import { type SessionDto } from '@musleempay/shared';

/**
 * Where a signed-in user belongs.
 *
 * A platform operator who is not attached to any store has no merchant
 * dashboard to land on — every page of it needs a store — so they start at the
 * platform area instead. An operator who also runs a store keeps the
 * dashboard, as does everyone else.
 */
export function homePathFor(session: Pick<SessionDto, 'isPlatformAdmin' | 'merchant'>): string {
  return session.isPlatformAdmin && session.merchant === null ? '/admin' : '/dashboard';
}
